import React from 'react'
import Header from '../../component/Header'
import OLevel from '../OLevel'
import Footer from '../../component/Footer'

export default function LayoutOLevel() {
    return (
        <div>
            <Header />
            <OLevel />
            <Footer />
        </div>
    )
}
